export default __webpack_public_path__ + "static/media/flor.c4d8b074.jpeg";